var _rect, _path, _path2, _circle, _circle2, _line, _line2, _line3, _line4, _line5, _line6, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFoundationModels(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 8,
    fill: "#1A1A2E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 12L58 22V42L40 52L22 42V22L40 12Z",
    stroke: "#7B68EE",
    strokeWidth: 1.5,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20L50 26V38L40 44L30 38V26L40 20Z",
    stroke: "#9B8AFB",
    strokeWidth: 1.5,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 32,
    r: 6,
    fill: "#7B68EE",
    opacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 32,
    r: 3,
    fill: "#B8A9FF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 12,
    x2: 40,
    y2: 20,
    stroke: "#7B68EE",
    strokeWidth: 1,
    opacity: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 58,
    y1: 22,
    x2: 50,
    y2: 26,
    stroke: "#7B68EE",
    strokeWidth: 1,
    opacity: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 58,
    y1: 42,
    x2: 50,
    y2: 38,
    stroke: "#7B68EE",
    strokeWidth: 1,
    opacity: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 52,
    x2: 40,
    y2: 44,
    stroke: "#7B68EE",
    strokeWidth: 1,
    opacity: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 42,
    x2: 30,
    y2: 38,
    stroke: "#7B68EE",
    strokeWidth: 1,
    opacity: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 22,
    x2: 30,
    y2: 26,
    stroke: "#7B68EE",
    strokeWidth: 1,
    opacity: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 65,
    textAnchor: "middle",
    fill: "#9B8AFB",
    fontSize: 8,
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold"
  }, "FM")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoundationModels);
export default __webpack_public_path__ + "static/media/foundation-models.8d5ec97b49f55ccd5680fabfed67c6bb.svg";
export { ForwardRef as ReactComponent };